import $ from 'jquery';

const animations = () => {

  // Super simple way to set a parent container as "loaded" when a child element loads
  window.elementLoaded = (element) => {
    $(element).closest('.AnimateOnLoad').addClass('Animate').removeClass('.AnimateOnLoad');
    $(window).trigger('scroll');
  };

  // Check for any "preloaded" images and basically do the same thing as the elementLoaded function above.
  // These are images that loaded before this JS file could even execute, which are handled by some inline JS in theme.liquid
  $('.AnimateOnLoad--preloaded').each((i, element) => {
    // If it's preloaded, let it animate in with nice looking delays like other animations
    $(element).closest('.AnimateOnLoad').addClass('Animate').removeClass('.AnimateOnLoad');
  });

  $(window).scroll(() => {
    const scroll_top = $(window).scrollTop();
    const window_height = $(window).height();
    const trigger = (window_height * 0.9) + scroll_top;
    let delay = 0;

    /**
     * SILKY SMOOTH ANIMATION DELAYS :)
     * Delays are now coming from CSS animation-delay rather than setTimeouts.
     * 
     * setTimeout is the MINIMUM time that must pass until your JS is put in the queue of the event loop.
     * So if a bunch of other shit is going on (like during page load) you might see your "50ms" delays do something like this:
     * 50ms, 210ms, 250ms, 250ms, 250ms
     * 
     * Instead of this:
     * 50ms, 100ms, 150ms, 200ms, 250ms
     * 
     * Note that this solution is by no means perfect. If you scroll extremely fast, you may have a few items on your screen that are
     * "new" so they start over with 0ms delays and animate in before the last few items above them have animated. 
     * That said, you have to be doing some pretty stupid type of scrolling and it doesn't look terrible when it happens.
    **/ 

    $('.Animate:not(.Animate--animated), .Animate-when-loaded:not(.Animate--animated)').each((i, element) => {
      const $element = $(element);

      if ($element.offset().top + $element.height() < scroll_top) {
        // This item is above the viewable screen, animate it immediately and don't delay
        // We don't want to wait for our in-view items to show up if we reload a page half-way scrolled down.
        // Previously, all of the items above the viewable screen would add a 50ms delay each and you could be waiting 2-3 seconds
        // for all of those things to animate before the ones you can actually see would begin animating in.
        $element.css('animation-delay', '0ms').css('transition-delay', '0ms').addClass('Animate--animated');
      } else if ($element.offset().top <= trigger) {        
        $element.css('animation-delay', `${delay}ms`).css('transition-delay', `${delay}ms`).addClass('Animate--animated');

        delay += 50;
      }
    });
  });
};

export { animations };